module.exports = __webpack_public_path__ + "static/img/zuanshi.fa5d687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/vip/zuanshi.png
// module id = DSto
// module chunks = 2